var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2"},[(_vm.themeLight)?_c('span',{staticClass:"fas fa-moon",class:_vm.themeLight ? 'animate__animated animate__wobble' : '',staticStyle:{"font-size":"18px","cursor":"pointer"},on:{"click":function($event){_vm.themeLight = false
      _vm.Moon()}}}):_c('span',{staticClass:"fas fa-sun",class:_vm.themeLight ? 'animate__animated animate__wobble' : '',staticStyle:{"font-size":"18px","cursor":"pointer"},on:{"click":function($event){_vm.themeLight = true
      _vm.Sun()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }